const AllItemsConstants = {
  REFRESH: 'SR_ALL_REFRESH'
};

export default AllItemsConstants;
